
import { defineComponent, reactive, provide } from 'vue';
import { AreaSelection } from '@/types/AreaSelection';
import { clsEstimateCond } from '@/types/clsEstimateCond';
import { clsEstimateData } from '@/types/clsEstimateData';
import LoginPanel from '@/components/LoginPanel.vue';
import { clsUser } from '@/types/clsUser';

export default defineComponent({
  components: { LoginPanel },
  setup() {
    const AreaSelection: AreaSelection = reactive({
      weekly: [],
      monthly: []
    })
    provide('area_selection', AreaSelection)
    const user = reactive(new clsUser())
    //provide('user', user)
    function login(arg: any) {
      Object.assign(user, arg)
    }
    const EstimateCond: clsEstimateCond = reactive(new clsEstimateCond('nokina','B4'))
    provide('econd', EstimateCond)
    const EstimateData: clsEstimateData = reactive(new clsEstimateData())
    provide('estdata', EstimateData)

    return {
      user,
      login
    }
  }
})
